import { c as _c } from "react/compiler-runtime";
import { Search } from "lucide-react";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
import { useRegionCode } from "modules/i18n/hooks/useRegionCode";
import { pageUrl } from "common/lib/router";
import { useId } from "react";
export const SearchForm = () => {
  "use memo";

  const $ = _c(22);
  const t = useTranslations("layout.header");
  const regionCode = useRegionCode();
  let t0;
  if ($[0] !== regionCode) {
    t0 = pageUrl.view({
      regionCode,
      pageSlug: "search"
    });
    $[0] = regionCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchPath = t0;
  const searchInputId = useId();
  let t1;
  if ($[2] !== t) {
    t1 = t("search_placeholder");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== searchInputId || $[5] !== t1) {
    t2 = <label htmlFor={searchInputId} className="sr-only">{t1}</label>;
    $[4] = searchInputId;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("search_placeholder");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== searchInputId || $[10] !== t3) {
    t4 = <input id={searchInputId} type="search" name="q" className="box-border w-full rounded-full border border-solid border-gray-300 py-3 pr-10 pl-5 font-sans text-base text-black placeholder:text-gray-600/100" placeholder={t3} />;
    $[9] = searchInputId;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t) {
    t5 = t("search");
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Search name="Search" role="search" className="size-6" aria-hidden="true" />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5) {
    t7 = <div className="absolute inset-y-0 right-3 flex items-center"><button aria-label={t5} type="submit" value="Search" className="mt-px flex cursor-pointer items-center justify-center border-none bg-transparent text-gray-800">{t6}</button></div>;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== searchPath || $[18] !== t2 || $[19] !== t4 || $[20] !== t7) {
    t8 = <form action={searchPath} acceptCharset="UTF-8" method="get" className="relative mx-2 my-3 flex basis-1/3 flex-row content-around lg:my-4" role="search">{t2}{t4}{t7}</form>;
    $[17] = searchPath;
    $[18] = t2;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};